import { Component } from 'react';
import { connect } from 'react-redux';

import { Button, Heading, Pane } from 'evergreen-ui';
import InfoBlock from '../../common/InfoBlock/InfoBlock';

import { Link } from 'react-router-dom';

import Configuration from '../Config';
import { createCardExpansion } from '../actions/cardExpansionActions';
import CardExpansionForm from '../components/CardExpansionForm';
import CardTraderExpansionPickerModal from '../components/CardTraderExpansionPickerModal';


const validation = Configuration.Validations.editStockAccount;
const mapValidationErrors = Configuration.ErrorHandler.mapValidationErrors;

// Map CardTrader game_id -> internal cardGameId
const CM_GAME_ID_BY_CT_ID = {
    1: 1,    // Magic the Gathering
    4: 3,    // Yu-Gi-Oh!
    5: 6,    // Pokemon
    15: 18,  // One Piece
    20: 21   // Star Wars Unlimited
};

class CreateCardExpansion extends Component {
    constructor(props) {
        super(props);

        this.state = {
            formValues: { ...Configuration.Defaults.createCardExpansion },
            pickerOpen: false
        };
    }

    handleSave = (values) => {
        this.props.dispatch(createCardExpansion(values));
    }

    openPicker = () => this.setState({ pickerOpen: true });
    closePicker = () => this.setState({ pickerOpen: false });

    handleCardTraderPick = (expansion) => {
        this.setState((state) => {
            const current = state.formValues;
            const next = { ...current };

            const isEmpty = (v) => v === '' || v === null || v === undefined;

            if (isEmpty(next.name) && expansion.name) {
                next.name = expansion.name;
            }
            if (isEmpty(next.code) && expansion.code) {
                next.code = expansion.code;
            }
            if (isEmpty(next.cardTraderId) && expansion.id) {
                next.cardTraderId = expansion.id;
            }
            // Always set the game from the picked CardTrader expansion so
            // the form's "Game" selector reflects the choice immediately.
            const mappedGameId = expansion.cardGameId || CM_GAME_ID_BY_CT_ID[expansion.game_id];
            if (mappedGameId) {
                next.cardGameId = String(mappedGameId);
            }

            return { formValues: next };
        });
    }

    render() {
        const { formValues, pickerOpen } = this.state;

        return (
            <Pane padding={16} paddingTop={0}>
                <Pane display="flex">
                    <Pane>
                        <Link to="/card-expansions">
                            <Button iconBefore="arrow-left" intent="none">
                                Inapoi la lista extensii
                            </Button>
                        </Link>
                    </Pane>
                </Pane>

                <Pane flex={1} background="tint1" elevation={1} padding={16} marginTop={16} display="flex" justifyContent="space-between" alignItems="center">
                    <Heading size={600}>
                        Creare Extensie
                    </Heading>
                    <Button
                        type="button"
                        appearance="primary"
                        intent="none"
                        iconBefore="cloud-download"
                        onClick={this.openPicker}
                    >
                        Populeaza din CardTrader
                    </Button>
                </Pane>

                <Pane display="flex" justifyContent="space-between" flex={1} marginTop={16}>
                    <InfoBlock flex="1">
                        <CardExpansionForm
                            isEdit={false}
                            initialValues={formValues}
                            validationSchema={validation}
                            onSave={this.handleSave}
                            errors={this.props.errors} />
                    </InfoBlock>
                </Pane>

                <CardTraderExpansionPickerModal
                    isShown={pickerOpen}
                    onClose={this.closePicker}
                    onPick={this.handleCardTraderPick}
                    cardGameId={formValues.cardGameId}
                />
            </Pane>
        )
    }
}

function mapStateToProps(state) {
    return {
        errors: state.cardExpansions.errors.type === 'validation' ? mapValidationErrors(state.stockAccounts.errors.fields): [],
        cardExpansion: state.cardExpansions.current
    }
}

export default connect(mapStateToProps)(CreateCardExpansion);
